// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { CopyPlus as RawCopyPlus } from "lucide-react";
export const CopyPlus = /* @__PURE__ */ createIcon(RawCopyPlus, "CopyPlus", 2);
